import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from '@/layout/MainLayout';
import Login from '@/view/Login';
import Dashboard from '@/view/Dashboard';
import Facilities from '@/view/Facilities';
import FacilitiesDetail from '@/view/FacilitiesDetail';
import Model from '@/view/Model';
import ModelDetail from '@/view/ModelDetail';
import Device from '@/view/Device';
import DeviceDetail from '@/view/DeviceDetail';
import Event from '@/view/Event';
import Userlist from '@/view/Userlist';
import SmsList from '@/view/SmsList';
import UserDivisionList from '@/view/UserDivisionList';
import DistributorList from '@/view/DistributorList';
import SiteList from '@/view/SiteList';
import NoticeList from '@/view/NoticeList';
import Test from '@/view/Test';

const isAuthenticated = () => {
  const token = sessionStorage.getItem('accessToken');
  return !!token;
};

const Router = () => {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              <Navigate to="/dashboard" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route path="/login" element={<Login />} />
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/facilities/detail/:id" element={<FacilitiesDetail />} />
          <Route path="/model" element={<Model />} />
          <Route path="/model/detail/:id" element={<ModelDetail />} />
          <Route path="/device" element={<Device />} />
          <Route path="/device/detail/:id" element={<DeviceDetail />} />
          <Route path="/event" element={<Event />} />
          <Route path="/userlist" element={<Userlist />} />
          <Route path="/smslist" element={<SmsList />} />
          <Route path="/userdivisionlist" element={<UserDivisionList />} />
          <Route path="/distributorlist" element={<DistributorList />} />
          <Route path="/sitelist" element={<SiteList />} />
          <Route path="/noticelist" element={<NoticeList />} />
          <Route path="/test" element={<Test />} />
        </Route>
      </Routes>
    </>
  );
};

export default Router;
